// extracted by mini-css-extract-plugin
module.exports = {"paymentSC":"PaymentMethodSegmentedControl_paymentSC__3L6Gw","selected":"PaymentMethodSegmentedControl_selected__qoDC9"};